const DateUtil = {
  toStrDate: (date) => {
    var isStringObj = date && typeof date === 'string';
    //console.log(isStringObj);
    if(!date || isStringObj)
      return date;
    //if (!date) return "";
    return (
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "/" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "/" +
      date.getFullYear()
    );
  },

  toIsoStrDate: (date) => {
    if (!date) return "";
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "-" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
    );
  },

  toDate:(str)=>{
    var isDateObj = str && Object.prototype.toString.call(str) === "[object Date]" && !isNaN(str);
    //console.log(isDateObj);
    if(!str || isDateObj)
      return str;
    var parts = str.split("/");
    var dt = new Date(parseInt(parts[2], 10),
                      parseInt(parts[0], 10) - 1,
                      parseInt(parts[1], 10));
                      return dt;
  },

};

export default DateUtil;
